import { render, staticRenderFns } from "./AufgabeBoardItemCard.vue?vue&type=template&id=6c7de451"
import script from "./AufgabeBoardItemCard.vue?vue&type=script&lang=ts"
export * from "./AufgabeBoardItemCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports